import {ClickToPause as ClapprClickToPause} from '@clappr/plugins'
import type {Options} from '@clappr/core'

export class ClickToPause<T extends Options> extends ClapprClickToPause<T> {
  public click(): void {
    if (this.container.isPlaying()) {
      this.container.pause()
    } else {
      this.container.play()
    }
  }

  public settingsUpdate(): void {
    if (this.pointerEnabled) {
      return
    }

    this.container.$el.addClass('pointer-enabled')
    this.pointerEnabled = true
  }
}
